import _ from 'underscore';

import getUrlBuilders from './url-builder';
import * as UrlHelper from './url-helper';

const getUrlHelpers = ({
  ccBaseUrl, FwLinkBaseUrl, CampaignAzureDomain, cid, uid,
}) => ({
  ..._.omit(UrlHelper, 'getTermsAndConditionsUrl'),
  TermsAndConditionsUrl: UrlHelper.getTermsAndConditionsUrl(ccBaseUrl),
  getForwardLink: _.partial(UrlHelper.getForwardLink, FwLinkBaseUrl),
  getErrorPageUrl: _.partial(UrlHelper.getErrorPageUrl, ccBaseUrl),
  getSAPApplicationSupportingDocumentUrl: _.partial(UrlHelper.getSAPApplicationSupportingDocumentUrl, ccBaseUrl, cid, uid),
  getAccountTaxCertificationUrl: _.partial(UrlHelper.getAccountTaxCertificationUrl, ccBaseUrl, cid, uid),
  getCampaignPageUrl: _.partial(UrlHelper.getCampaignPageUrl, CampaignAzureDomain),
});

export {
  getUrlBuilders,
  getUrlHelpers,
  UrlHelper,
};
